"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TurnstileAction = exports.TURNSTILE_MAX_TOKEN_LENGTH = void 0;
exports.TURNSTILE_MAX_TOKEN_LENGTH = 2048;
exports.TurnstileAction = {
    contact: 'contact',
    registerCandidate: 'register-candidate',
    registerCompany: 'register-company',
};
